import React, { useState } from "react";
import { connect, useDispatch } from 'react-redux';
import Select from 'react-select';

import { addChatRoom } from "../../actions";
import DashboardMembers from "../components/dashboard/Members";
import { resetDrawer } from "../../actions/toggleAction";
import { FormattedMessage, useIntl } from "react-intl";
import { useNavigate } from "react-router-dom";

const AddChatDrawer = (props) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {
    currentWorkspace,
    user,
    chats
  } = props;

  const [chatName, setChatName] = useState('');
  const [members, setMembers] = useState(currentWorkspace?.members);
  const [assigneeValue, setAssigneeValue] = useState([]);

  const isButtonDisabled = 
  (assigneeValue.length === 0 && !chatName) || // Disabled if both chatName is null and assigneeValue is empty
  (assigneeValue.length > 1 && !chatName);    // Disabled if multiple assignees but no chatName
  // const isButtonDisabled = !chatName || assigneeValue?.length == 0;

  const formatOptionLabel = ({ label, avi }) => (
    <div className='flex align-center'>
      {avi && (
        <img
          className="h-6 w-6 rounded-full mr-3"
          src={avi} />
      )}
      <div className='font-weight-500'>{label}</div>
    </div>
  );

  const createChatRoom = async () => {
    if (isButtonDisabled) {
      return;
    }

    const createdChat = await dispatch(addChatRoom({ members: assigneeValue?.map(x => x?.value), roomName: chatName, workspaceId: currentWorkspace?._id }));
    dispatch(resetDrawer());
    setChatName('');
    setTimeout(() => {
      navigate(`/chat/${createdChat._id.toString()}`);
    }, 100);
  };

  return (
    <div className='h-full flex flex-col w-full'>
      {/* Header */}
      <div className='h-40 flex-shrink-0 flex flex-col p-8' style={{ justifyContent: 'flex-end', background: 'linear-gradient(135deg, #4f46e5 0%, #4338ca 100%)' }}>
        <div className='text-white font-black text-2xl'>
          <FormattedMessage id="START_NEW_CHAT" defaultMessage="Start a new chat" />
        </div>
      </div>

      {/* Fixed inputs */}
      <div className='flex-shrink-0 p-4 space-y-4'>
        <div className="space-y-2">
          <label className="text-sm font-medium text-gray-700"><FormattedMessage id="CHAT_NAME" defaultMessage="Chat Name" /></label>
          <input
            type='text'
            value={chatName}
            placeholder={intl.formatMessage({ id: 'NAME_NEW_CHAT_GROUP', defaultMessage: 'Name your new chat group' })}
            onChange={e => setChatName(e?.target?.value)}
            className="w-full bg-white text-sm font-medium text-slate-800 px-4 py-2.5 rounded-lg outline-none transition duration-150"
            style={{ border: '1.5px solid rgba(99,102,241,0.35)', boxShadow: 'none' }}
            onFocus={e => { e.target.style.border = '1.5px solid #4f46e5'; e.target.style.boxShadow = '0 0 0 3px rgba(99,102,241,0.12)'; }}
            onBlur={e => { e.target.style.border = '1.5px solid rgba(99,102,241,0.35)'; e.target.style.boxShadow = 'none'; }} />
        </div>
        <div className="space-y-2">
          <label className="text-sm font-medium text-gray-700"><FormattedMessage id="SEARCH_MEMBERS" defaultMessage="Search members" /></label>
          <Select
            value={assigneeValue}
            isMulti
            isClearable={false}
            options={members
              ?.filter((newUser) => !assigneeValue?.some((existingUser) => existingUser?._id === newUser?._id))
              ?.map((participant) => ({ value: participant?._id, label: participant?.fullName, avi: participant?.avi }))}
            placeholder={intl.formatMessage({ id: 'SELECT_PLACEHOLDER', defaultMessage: 'Select…' })}
            formatOptionLabel={formatOptionLabel}
            onChange={(participants) => {
              const x = currentWorkspace?.members?.filter(user => !participants?.find(p => p?.value == user?._id));
              setMembers(x);
              setAssigneeValue(participants);
            }}
            autoFocus={true}
            components={{ DropdownIndicator: () => null, IndicatorSeparator: () => null }}
          />
        </div>
      </div>

      {/* Scrollable member list — fills remaining space */}
      <div className="flex-1 overflow-y-auto min-h-0 px-2">
        {members?.map(member => (
          <DashboardMembers
            key={member._id}
            me={user?._id}
            member={member}
            chats={chats}
            callback={(participant) => {
              setAssigneeValue([...assigneeValue, { value: participant?._id, label: participant?.fullName, avi: participant?.avi }]);
              setMembers(members?.filter(user => user?._id !== participant?._id));
            }}
            workspaceId={currentWorkspace?._id} />
        ))}
      </div>

      {/* Footer button */}
      <div className="flex-shrink-0 px-4 py-4 border-t" style={{ borderColor: 'rgba(99,102,241,0.1)' }}>
        <div
          onClick={createChatRoom}
          className={`w-full text-center px-4 py-3 text-sm font-semibold text-white rounded-lg transition-colors ${isButtonDisabled ? 'opacity-60 cursor-not-allowed' : 'cursor-pointer'}`}
          style={{ background: isButtonDisabled ? 'rgba(99,102,241,0.5)' : '#4f46e5' }}>
          <FormattedMessage id="CREATE_CHAT" defaultMessage="Create Chat" />
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  user: state.userReducer.user,
  currentWorkspace: state.workspaceReducer.currentWorkspace,
  chats: state.chatReducer.chats,
});

export default connect(mapStateToProps)(AddChatDrawer);
